export default __webpack_public_path__ + "static/media/english.c06e4ba9.png";